import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import {
  GHACugTierChainRule,
  UpsertGHACugTierChainRuleBody,
  deleteGHACugTierChainRule,
  listGHACugTierChainRules,
  upsertGHACugTierChainRule,
} from '~/services/ConnectionGoogleService';

export const ghaCugTierChainRuleQueryKeys = {
  all: ['ghaCugTierChainRules'] as const,
};

export function useGHACugTierChainRules() {
  return useQuery({
    queryKey: ghaCugTierChainRuleQueryKeys.all,
    queryFn: async ({ signal }) => (await listGHACugTierChainRules({ signal })).result,
  });
}

export function useUpsertGHACugTierChainRule() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (input: UpsertGHACugTierChainRuleBody) => await upsertGHACugTierChainRule(input),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ghaCugTierChainRuleQueryKeys.all });
      enqueueSnackbar(`Saved ${response.result.chainName}`, { variant: 'success' });
    },
  });
}

export function useDeleteGHACugTierChainRule() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (rule: GHACugTierChainRule) => await deleteGHACugTierChainRule(rule.id),
    onSuccess: (_response, rule) => {
      queryClient.invalidateQueries({ queryKey: ghaCugTierChainRuleQueryKeys.all });
      enqueueSnackbar(`Deleted ${rule.chainName}`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to delete: ${error.message}`, { variant: 'error' });
    },
  });
}
